import { fetchTranslationData } from "../../services/translation/translation";
import { config, ServiceTranslation } from "../../utils/constants";
import { useEffect, useState } from "react";
import { capitalizeWords, getLayoutDirection } from "../../utils/util";
import { getQRCodeDetail } from "../../services/liferay/sickleave";
import Warning from "../common/Warning";
import { Loader } from "../../common/Loader";

const SickLeaveQrVefication = () => {
  const [translationMap, setTranslationMap] = useState(null);
  const [qrData, setQrData] = useState(null);
  const [error, setError] = useState(null);

  const urlParams = window.location.search;
  // Strip any appended garbage (e.g. page title like "%20SickLeave%20Verfication") starting from first %20
  const encode = urlParams.match(/encode=([^&]*)/)?.[1]?.replace(/(%20| ).*$/, '');

  useEffect(() => {
    fetchTranslationData(ServiceTranslation.SickLeave).then(setTranslationMap);

    getQRCodeDetail(encode)
    .then((result) => {
      if (result.status === 200) {
        setQrData(result.data.data);
      } else {
        setError("Invalid QR Code or data not found.");
      }
    })
    .catch((err) => {
      setError("Something went wrong while fetching data.");
      console.error(err);
    });
  }, [encode]);

  if (error) {
    return (
      <div className={`custombody_color ${getLayoutDirection()}`} id="sectionSickLeaveQr">
                <section className="w-100 clearfix SickLeaveConfirmationSection" id="CoverPlanActive">
                    <div className="barcode_header">
                        <div className="container customContainer">
                            <div className="inner_header_box">
                                {[1, 2, 3].map((i) =>
                <div className="img_box" key={i}>
                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                        <a>
                                            <img
                      src={`${config.assestsBase}img/sickleave_barcode_img${i}.svg`}
                      alt="Displaying dubaihealth logo"
                      className={i === 2 ? "desktop_img" : ""} />
                    
                                            {i === 2 &&
                    <img
                      src={`${config.assestsBase}img/sickleave_barcode_res_img2.svg`}
                      alt="Displaying dubaihealth logo"
                      className="responsive_img" />

                    }
                                        </a>
                                    </div>
                )}
                            </div>
                        </div>
                    </div>

                    <div className="container customContainer">
                        <div className="Title_Inner_Box">
                            <h6 className="MainTitleOne">
                                {translationMap?.sick_leave_application_verification}
                            </h6>
                        </div>

                        <Warning heading={translationMap?.invalidQRMessage} desc="" />
                    </div>
                </section>
            </div>);

  }

  if (!translationMap || !qrData) return <Loader />;

  const {
    name,
    emiratesId,
    certificateNumber,
    dateOfIssue,
    returnToWork,
    mrn
  } = qrData;

  return (
    <div className={`custombody_color ${getLayoutDirection()}`} id="sectionSickLeaveQr">
            <section className="w-100 clearfix SickLeaveConfirmationSection" id="CoverPlanActive">
                <div className="barcode_header">
                    <div className="container customContainer">
                        <div className="inner_header_box">
                            {[1, 2, 3].map((i) =>
              <div className="img_box" key={i}>
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                    <a>
                                        <img
                    src={`${config.assestsBase}img/sickleave_barcode_img${i}.svg`}
                    alt="Displaying dubaihealth logo"
                    className={i === 2 ? "desktop_img" : ""} />
                  
                                        {i === 2 &&
                  <img
                    src={`${config.assestsBase}img/sickleave_barcode_res_img2.svg`}
                    alt="Displaying dubaihealth logo"
                    className="responsive_img" />

                  }
                                    </a>
                                </div>
              )}
                        </div>
                    </div>
                </div>

                <div className="container customContainer">
                    <div className="Title_Inner_Box">
                        <h6 className="MainTitleOne">
                            {translationMap?.sick_leave_application_verification}
                        </h6>
                    </div>

                    <div className="cover_inner_wrapper">
                        <div className="cover_main_box1">
                            <div className="AlertInnerBox GreenAlertInnerBox alert alert-dismissible fade show">
                                <button type="button" className="close" data-dismiss="alert">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M17 7L7 17M7 7L17 17" stroke="#002F70" strokeWidth="2"
                    strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </button>
                                <div className="Icon_box">
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                    <a><span className="material-symbols-outlined">check_circle</span></a>
                                </div>
                                <div className="alert_text">
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                    <h6><a>{translationMap?.certificate_is_verified}</a></h6>
                                    <p className="number_txt">
                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                        <a>{translationMap?.dubai_health_info_correct}</a>
                                    </p>
                                </div>
                            </div>

                            <div className="Sick_Leave_Main_Wrapper">
                                <div className="status_main_box status_main_box2">
                                    <div className="content_box">
                                        <ul className="detail_box">
                                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                            <li><p><span>{translationMap?.name}</span><a>{capitalizeWords(name)}</a></p>
                                            </li>
                                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                            <li><p><span>{translationMap?.emirates_id}</span><a>{emiratesId}</a></p>
                                            </li>
                                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                            <li><p><span>{translationMap?.mrn}</span><a>{mrn}</a></p></li>
                                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                            <li><p><span>{translationMap?.certificate}</span><a>{certificateNumber}</a>
                                            </p></li>
                                            <li>
                                                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                                <p><span>{translationMap?.valid_from}:</span><a>{dateOfIssue}</a></p>
                                                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                                <p><span>{translationMap?.to}:</span><a>{returnToWork}</a></p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="cover_main_box2"></div>
                    </div>
                </div>
            </section>
        </div>);

};

export default SickLeaveQrVefication;